import licenseModule from './license.module';

export default licenseModule.config($stateProvider =>
    $stateProvider
        .state({
            parent: 'app',
            name: 'license',
            url: '/license',
            component: 'license',
            redirectTo: 'license_overview'
        })
        .state({
            parent: 'license',
            name: 'license_overview',
            url: '/overview',
            component: 'licenseOverview',
            protected: true
        })
        .state({
            parent: 'license',
            name: 'license_manage',
            url: '/manage',
            component: 'licenseManagement',
            protected: true
        })
        .state({
            name: 'newserver',
            url: '/license/servers/new',
            component: 'licenseConsoleNewServer',
            onEnter(asNavBarService) {
                asNavBarService.hide();
            },
            onExit(asNavBarService) {
                asNavBarService.show();
            }
        })
        .state({
            parent: 'license',
            name: 'license_otherwise',
            url: '/*path',
            redirectTo: 'license_overview'
        })
);



// WEBPACK FOOTER //
// ./modules/license/license.states.js